module.exports = "/images/everestPath4.png?e363c4f443f99061106d36bc59d2101e";